import React, { useState } from "react"
import PropTypes from "prop-types"
import { Container, Title, Content, Option } from "./styles"
import Grid from "../grid"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/free-solid-svg-icons"

const ButtonSelect = ({ title, options, clickHandler, size }) => {
  const [show, setShow] = useState(false)

  const handleClick = (event, option) => {
    setShow(false)
    if (clickHandler !== undefined) clickHandler(event, option)
  }

  return (
    <Container show={show}>
      <Title size={size} onClick={() => setShow(!show)}>
        {title}&nbsp;&nbsp;
        <FontAwesomeIcon icon={faChevronDown} />
      </Title>
      <Content show={show}>
        <Grid gap="0">
          {options.map((option) => (
            <Option size={size} key={option} onClick={(event) => handleClick(event, option)}>
              {option}
            </Option>
          ))}
        </Grid>
      </Content>
    </Container>
  )
}

ButtonSelect.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array,
  clickHandler: PropTypes.func,
  size: PropTypes.oneOf(["default", "small"])
}

ButtonSelect.defaultProps = {
  title: "Please select",
  options: [],
  clickHandler: undefined,
  size: "default"
}

export default ButtonSelect
